var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3375 4696 c-89 -39 -127 -156 -80 -246 8 -14 126 -137 264 -275 l251 -250 -915 -915 c-859 -860 -915 -918 -915 -950 0 -31 17 -51 188 -222 171 -172 191 -188 222 -188 33 0 89 55 950 915 l915 915 260 -259 c228 -227 265 -261 304 -271 74 -20 146 7 195 73 21 28 21 35 24 793 2 749 2 765 -18 804 -12 24 -36 49 -63 65 l-44 25 -754 0 c-604 -1 -760 -3 -784 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710 4341 c-160 -34 -294 -112 -414 -243 -124 -133 -187 -272 -206 -455 -7 -65 -10 -503 -8 -1303 3 -1200 4 -1205 25 -1281 90 -318 360 -553 676 -589 62 -8 492 -10 1312 -8 1374 4 1268 -2 1440 83 152 75 286 209 360 360 81 163 79 143 83 742 l3 533 -25 25 c-24 24 -30 25 -155 25 -189 0 -171 53 -171 -514 0 -487 -5 -556 -45 -644 -28 -61 -108 -149 -174 -191 -101 -65 -30 -62 -1402 -59 l-1244 3 -65 31 c-82 40 -143 93 -190 166 -75 115 -71 37 -68 1418 l3 1235 31 65 c56 117 145 199 265 242 l64 23 1020 2 c561 2 1030 5 1042 8 42 10 55 55 51 182 -3 112 -4 115 -31 139 l-28 24 -1032 -1 c-954 0 -1038 -2 -1117 -18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.08ebd548a76b8e8b785ca6ded3c7a220.svg";
export { ForwardRef as ReactComponent };